// ----------------------------------------------------------------------

export default function Menu(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
}
